/* eslint-disable import/prefer-default-export */
export function formatPath(path) {
  let link = path;
  if (path.charAt(0) !== '/') {
    link = `/${path}`;
  }

  return link;
}
